<template>
	<div id="app">
		<transition name="router-fade" mode="out-in">
			<router-view v-if="!$route.meta.keepAlive"/>
		</transition>
	</div>
</template>

<script>
  //import layout from './components/layout'
  export default {
    components: {},
    data() {
      return {}
    },
    mounted() {
      let beforeUrl = sessionStorage.getItem('router-path')
      if(beforeUrl === undefined || beforeUrl === ''){
        //this.$router.push("/workPanel")
      }else {
        //this.$router.push(beforeUrl)
      }

    },
    created() {
      // 如果有 token 但没有用户信息，则重新获取
      const token = localStorage.getItem('token')
      const userInfo = this.$store.state.userInfo
      
      if (token && !userInfo) {
        this.initUserInfo()
      }
    },
    methods: {
      async initUserInfo() {
        try {
          const response = await caseApi.getuserinfo()
          if (response.status === 200) {
            this.$store.commit('setUserInfo', response.data)
          }
        } catch (error) {
          console.error('获取用户信息失败:', error)
          // 如果获取失败，可能是 token 过期，清除登录状态
          localStorage.removeItem('token')
          this.$router.push('/login')
        }
      }
    }
  }
</script>
<style lang="less">
	@import "@/assets/global";
	:focus {
		outline: -webkit-focus-ring-color auto 0px;
	}
	body {
		margin: 0;
		min-width: 500px;
		background-color: #f5f5f5;
	}
	body,html {margin:0; height:100%;}
	ul {
		padding: 0;
		margin: 0;

		li {
			list-style-type: none;
		}
	}
  .mainbox{
    width: 90%;
    margin: 0 auto;
    margin-top: 24px;
    padding: 24px;
    background-color: #fff;
  }

  .ov-tip{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .item-desc{
    font-size: small;
    color: #5e5e5e;
  }

  .max-fill{
    width: 100% !important;
  }

  // 全局滚动条样式
  ::-webkit-scrollbar {
    width: 8px;  // 垂直滚动条宽度
    height: 8px; // 水平滚动条高度
  }

  ::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 4px;
    
    &:hover {
      background: #bfbfbf;
    }
    
    &:active {
      background: #8c8c8c;
    }
  }

  // 在暗色背景下的滚动条
  .dark-bg {
    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.1);
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      
      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      &:active {
        background: rgba(255, 255, 255, 0.4);
      }
    }
  }

  // 在白色背景下的滚动条
  .light-bg {
    &::-webkit-scrollbar-track {
      background: #f5f5f5;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #e8e8e8;
      
      &:hover {
        background: #d9d9d9;
      }
      
      &:active {
        background: #bfbfbf;
      }
    }
  }

  // 细滚动条样式
  .thin-scrollbar {
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
  }
</style>
